import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { passwordInvite } from 'modules/account/features/forgotPassword/api';

export const useMutationPasswordInvite = () => {
  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync: passwordInviteMutate, isLoading: passwordInviteIsLoading } = useMutation(
    passwordInvite,
    {
      onSuccess: () => {
        successToast('Success');
      },
      onError: () => errorToast(),
    },
  );

  return { passwordInviteMutate, passwordInviteIsLoading };
};
